import React, { useState, useEffect } from "react";

import "./Form.css";
import axios from "axios";
import Loader from "../Loader/loader";
import Otp from "../Otp/Otp";
import Spiner from "../../assets/spiner.png";

import {
  sendOtpURL,
  confirmOtpURL,
  recargeWallet,
  getWallet,
} from "../../Utils/apis";
import Spinwheel from "../Spinwheel/spinwheel";

import { notification } from "antd";

import { Redirect, useHistory } from "react-router-dom";

const Form = () => {
  const [state, setState] = useState({
    authed: "notAuthenticated",
    // authed: false,
    msisdn: "",
    network: "",
    otp: "",
    wrongNum: false,
    showOtp: false,
    wrongOtp: false,
    isLoading: false,
    authenticated: false,
  });

  const {
    msisdn,
    network,
    otp,
    isLoading,
    wrongNum,
    showOtp,
    authed,
    authenticated,
  } = state;

  const addToLocalStorage = (msisdn, network) => {
    localStorage.setItem("msisdn", msisdn);
    localStorage.setItem("network", network);
  };

  const isAuthenticated = (authed) => {
    localStorage.setItem("authed", "authenticated");
  };

  const onChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
      showOtp: false,
    });
  };

  const onOTPChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const checkLength = () => {
    var long = document.getElementById("phoneNumber").value;
    var len = long.length;
    if (len !== 11) {
      setState({
        ...state,
        wrongNum: true,
      });
    } else {
      setState({
        ...state,
        wrongNum: false,
      });
    }
  };

  const openNotification = () => {
    const args = {
      message: "One-Time-Password",
      description: "Check your SMS. Input the sent OTP, OTP is valid For 24 hours",
      duration: 10,
    };
    notification.open(args);
  };

  const openConfirmNotification = () => {
    const args = {
      message: "OTP validation successful",
      description: "You can Now Proceed to make a spin",
      duration: 10,
    };
    notification.open(args);
  };

  const openErrorNotification = () => {
    const args = {
      message: "Error",
      description: "An Error Occoured",
      duration: 10,
    };
    notification.open(args);
  };

  const openCustomErrorNotification = (msg) => {
    const args = {
      message: "Error",
      description: msg,
      duration: 10,
    };
    notification.open(args);
  };

  const sendOTP = () => {
    addToLocalStorage(msisdn, network);
    setState({
      ...state,
      isLoading: true,
    });
    axios({
      method: "post",
      url: sendOtpURL,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        msisdn,
        network,
      },
    })
      .then(function (result) {
        console.log(result)
        if (
          result.status === 200 &&
          result.data.status === "OtpDuplicationError"
        ) {
          setState({
            ...state,
            showOtp: true,
            isLoading: false,
          });
          openCustomErrorNotification(result.data.message);
        }
        if (result.status === 200 && result.data.status === "success") {
          setState({
            ...state,
            showOtp: true,
            isLoading: false,
          });
          openNotification();
        }
      })
      .catch((error) => {
        console.log({error});
        setState({
          ...state,
          isLoading: false,
        });
      });
  };

  const validateOTP = () => {
    setState({
      ...state,
      isLoading: true,
    });
    axios({
      method: "post",
      url: confirmOtpURL,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        msisdn,
        otp,
      },
    })
      .then(function (result) {
        //   setting phonenumber and network to read only
        // document.getElementById("phoneNumber").readOnly = true;
        // document.getElementById("network").disabled = true;

        if ((result.status = 200)) {
          setState({
            ...state,
            showOtp: true,
            isLoading: false,
            authed: true,
          });
          localStorage.setItem("authed", "authenticated");
          console.log(state);
          // toggleOpen();
          openConfirmNotification();
        }
      })
      .catch((error) => {
        console.log(error);
        openCustomErrorNotification("Invalid otp");
        setState({
          ...state,
          isLoading: false,
        });
      });
  };

  return (
    <form>
      {!showOtp ? (
        <>
          <label className="form-label" for="name">
            PHONE NUMBER
          </label>
          <br></br>
          <input
            // type="text"
            className="my-select"
            placeholder="Phone number"
            icon="phone"
            type="number"
            id="phoneNumber"
            onBlur={checkLength}
            onChange={onChange}
            required="required"
            name="msisdn"
            value={msisdn}
          />
          <span
            className="error text-danger ml-1 bg-light"
            style={{ display: wrongNum ? "block" : "none" }}
          >
            Invalid Phone Number !!!
          </span>

          <br></br>

          <label className="form-label" for="job">
            SELECT NETWORK
          </label>
          <br></br>
          <select
            className="my-select"
            id="network"
            name="network"
            value={network}
            onChange={onChange}
            required
          >
            <option value="" disabled selected hidden>
              Choose network
            </option>
            <option value="9mobile">9MOBILE</option>
            <option value="mtn">MTN</option>
            <option value="glo">GLO</option>
            <option value="airtel">AIRTEL</option>
          </select>
          <br></br>
          <button
            className="button-submit btn-block p-3"
            type="button"
            onClick={sendOTP}
          >
            {isLoading ? <Loader /> : "CONFIRM"}
          </button>
        </>
      ) : (
        <>
          <div style={{ display: showOtp ? "block" : "none" }} className="my-3">
            <Otp
              placeholder="OTP"
              icon="eye-slash"
              type="password"
              id="otp"
              required="required"
              name="otp"
              value={otp}
              onChange={onOTPChange}
            />
            <span
              className="error text-danger ml-1 bg-light"
              style={{ display: wrongNum ? "block" : "none" }}
            >
              Invalid OTP
            </span>
          </div>

          <div className="d-flex justify-content-end mt-4">
            <button
              className="button-submit btn-block p-3"
              onClick={validateOTP}
              type="button"
            >
              {isLoading ? <Loader /> : "SUBMIT"}
            </button>
          </div>
        </>
      )}
    </form>
  );
};

export default Form;
